import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcabpackage() {



  const cardData =
  {
    keyword: 'Pune to Bhimashankar Cab Package',
    heading: 'Sanavi Travels: Pune to Bhimashankar Cab Package',
    headingDescription: 'Sanavi Travels offers reliable Pune to Bhimashankar Cab Package, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and groups traveling from Pune to the sacred Bhimashankar Jyotirlinga. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxed journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Bhimashankar Temple and nearby scenic and forested areas. Choose Sanavi Travels for trusted Pune to Bhimashankar cab packages, delivering comfort, safety, and a memorable pilgrimage travel experience.',

    top: 'Top Places to Visit in Bhimashankar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhimashankar Temple",
    "description": "Bhimashankar Temple is a revered Jyotirlinga shrine dedicated to Lord Shiva, located in the Sahyadri hills. Surrounded by dense forests and misty mountains, it is an important pilgrimage site. The temple’s traditional architecture and spiritual ambiance attract devotees and tourists alike, offering a serene and sacred experience."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary spans lush forests and hilly terrain, home to the endangered Indian Giant Squirrel (Shekru) and diverse flora and fauna. Visitors can enjoy trekking, birdwatching, and nature walks. The sanctuary offers a pristine environment for wildlife enthusiasts and nature lovers."
  },
  {
    "title": "Kushalgarh Waterfall",
    "description": "Kushalgarh Waterfall is a scenic waterfall near Bhimashankar, surrounded by dense greenery. Particularly vibrant during monsoon, it provides a tranquil spot for relaxation, photography, and enjoying nature’s beauty."
  },
  {
    "title": "Vajreshwari Hill Trek",
    "description": "Vajreshwari Hill Trek offers an adventurous trail with panoramic views of the Sahyadri ranges. The trek passes through dense forests, streams, and scenic landscapes, attracting trekking enthusiasts and nature explorers."
  },
  {
    "title": "Bhimashankar River",
    "description": "The Bhima River originates near Bhimashankar Temple, flowing through picturesque valleys and forested landscapes. It is considered sacred by pilgrims and offers a serene natural setting for visitors."
  },
  {
    "title": "Pawna Dam",
    "description": "Pawna Dam, located near Bhimashankar, is a popular spot for picnics, camping, and photography. Surrounded by hills and forests, it provides a peaceful retreat and scenic views, ideal for relaxation and nature exploration."
  },
  {
    "title": "Naneghat Pass",
    "description": "Naneghat is an ancient mountain pass connecting the Konkan coast to the Deccan plateau, near Bhimashankar. It features historic trade routes, natural springs, and trekking trails. Panoramic views of valleys and waterfalls make it a popular spot for adventurers and history enthusiasts."
  },
  {
    "title": "Saptashrungi Hills",
    "description": "Saptashrungi Hills are known for the Saptashrungi Devi Temple and surrounding scenic beauty. Located near Bhimashankar, the hills offer trekking trails, panoramic vistas, and a spiritual pilgrimage destination, blending nature and devotion."
  },
  {
    "title": "Chandoli National Park",
    "description": "Chandoli National Park, close to Bhimashankar, is part of the Western Ghats biodiversity hotspot. It is home to leopards, deer, and diverse bird species. Visitors can enjoy trekking, camping, and wildlife photography while exploring its rich ecological diversity."
  },
  {
    "title": "Kalsubai Peak",
    "description": "Kalsubai Peak, Maharashtra’s highest point, is located near Bhimashankar. The trek to the summit offers panoramic views of the Sahyadri ranges, waterfalls, and valleys. Popular among trekkers, it is especially scenic during the monsoon season, combining adventure and natural beauty."
  }
]
,




"services": [
  {
    "name": "Pune to Bhimashankar Cab Package",
    "description": "Pune to Bhimashankar Cab Package provides comfortable and reliable cab services for travelers planning a trip from Pune to Bhimashankar. Ideal for families, friends, and devotees, these cabs ensure a smooth journey with professional drivers, flexible pickup options, and well-maintained vehicles."
  },
  {
    "name": "Bhimashankar Cab from Pune",
    "description": "Bhimashankar Cab from Pune offers convenient transportation for tourists and pilgrims visiting Bhimashankar. Spacious interiors and experienced chauffeurs make this service perfect for day trips, weekend getaways, and religious visits."
  },
  {
    "name": "AC Cab Pune to Bhimashankar",
    "description": "AC Cab Pune to Bhimashankar provides air-conditioned vehicles for a comfortable journey. Ideal for long drives and pilgrimage trips, passengers can enjoy a cool and relaxing ride while professional drivers manage the route efficiently."
  },
  {
    "name": "Jyotirlinga Cab Package Pune",
    "description": "Jyotirlinga Cab Package Pune offers specialized cab services for travelers visiting Bhimashankar Jyotirlinga. Well-maintained vehicles, courteous drivers, and flexible scheduling ensure a seamless spiritual journey."
  },
  {
    "name": "Family Cab Bhimashankar",
    "description": "Family Cab Bhimashankar caters to families traveling from Pune to Bhimashankar. Spacious seating, child-friendly interiors, and experienced drivers make the journey safe, convenient, and enjoyable for all family members."
  },
  {
    "name": "Outstation Cab Bhimashankar",
    "description": "Outstation Cab Bhimashankar provides reliable cabs for long-distance travel from Pune. Comfortable seating, ample luggage space, and professional chauffeurs make it ideal for weekend trips, religious tours, and group travel."
  },
  {
    "name": "Affordable Cab Bhimashankar",
    "description": "Affordable Cab Bhimashankar offers budget-friendly options without compromising on comfort or safety. Perfect for solo travelers, families, and small groups seeking economical travel solutions from Pune to Bhimashankar."
  },
  {
    "name": "Chauffeur Driven Cab Bhimashankar",
    "description": "Chauffeur Driven Cab Bhimashankar ensures a stress-free travel experience with professional drivers handling traffic, routes, and pick-ups. Passengers can relax and enjoy the scenic drive to Bhimashankar."
  },
  {
    "name": "Best Cab Service Pune to Bhimashankar",
    "description": "Best Cab Service Pune to Bhimashankar offers top-quality vehicles and excellent customer service for a superior travel experience. Timely pick-ups, well-maintained cars, and skilled drivers ensure safe and reliable transport."
  },
  {
    "name": "Pune Bhimashankar Taxi",
    "description": "Pune Bhimashankar Taxi provides convenient and dependable taxi services for individuals and groups traveling from Pune to Bhimashankar. Comfortable, well-maintained vehicles and experienced drivers ensure a smooth and enjoyable journey."
  },
  {
    "name": "Religious Tour Cab Pune",
    "description": "Religious Tour Cab Pune offers cab services specially suited for pilgrims visiting Bhimashankar and other religious sites. Comfortable seating, luggage-friendly interiors, and professional chauffeurs ensure a hassle-free spiritual journey."
  },
  {
    "name": "Temple Darshan Cab Pune",
    "description": "Temple Darshan Cab Pune provides cabs for devotees planning temple visits in and around Bhimashankar. Spacious vehicles, courteous drivers, and safe travel ensure a comfortable and timely darshan experience."
  },
  {
    "name": "One Day Trip Cab Bhimashankar",
    "description": "One Day Trip Cab Bhimashankar offers cabs for day trips from Pune, making it convenient for tourists and devotees to visit Bhimashankar and return on the same day. Comfortable rides and experienced drivers ensure a smooth journey."
  },
  {
    "name": "Tourist Cab Bhimashankar",
    "description": "Tourist Cab Bhimashankar provides vehicles designed for sightseeing and leisure travel. Ideal for tourists visiting Bhimashankar, these cabs offer comfort, safety, and professional service for an enjoyable experience."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to conveniently reserve cabs for Pune to Bhimashankar trips. Flexible scheduling, transparent pricing, and professional service make planning your journey easy and reliable."
  }
],
"tableData": [
  ["Pune to Bhimashankar Cab Package", "Bhimashankar Cab from Pune"],
  ["AC Cab Pune to Bhimashankar", "Jyotirlinga Cab Package Pune"],
  ["Family Cab Bhimashankar", "Outstation Cab Bhimashankar"],
  ["Affordable Cab Bhimashankar", "Chauffeur Driven Cab Bhimashankar"],
  ["Best Cab Service Pune to Bhimashankar", "Pune Bhimashankar Taxi"],
  ["Religious Tour Cab Pune", "Temple Darshan Cab Pune"],
  ["One Day Trip Cab Bhimashankar", "Tourist Cab Bhimashankar"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bhimashankar Cab Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable Pune to Bhimashankar cab packages, ideal for devotees, group trips, and day excursions to the sacred Bhimashankar Jyotirlinga."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in air-conditioned, spacious, and regularly serviced cabs for a smooth and enjoyable journey from Pune to Bhimashankar."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in Pune to Bhimashankar routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Bhimashankar cab packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your travel preferences and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Bhimashankar cab packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab packages from Pune to Bhimashankar?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab packages for travel from Pune to Bhimashankar.'
  },
  {
    question: 'How can I book a Pune to Bhimashankar cab package?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Bhimashankar trips?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for a comfortable journey.'
  },
  {
    question: 'Are drivers experienced for Pune to Bhimashankar routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route to ensure safe travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off at Bhimashankar.'
  },
  {
    question: 'Is the cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services for your convenience.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All cabs are sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate account payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your travel from Pune to Bhimashankar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pradeep Shinde',
    feedback: 'The Pune to Bhimashankar cab package with Sanavi Travels was excellent. Comfortable ride and professional driver made our pilgrimage hassle-free.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sunita Patil',
    feedback: 'Highly satisfied! The cab was clean, air-conditioned, and the driver was very courteous. Perfect day trip to Bhimashankar.',
    rating: 5
  }
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab Package - Sanavi Travels",
  "description": "Book Pune to Bhimashankar cab package with Sanavi Travels. AC and luxury cabs for family trips, Jyotirlinga darshan, one-day trips, religious tours, and comfortable chauffeur-driven outstation travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Bhimashankar Cab Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Bhimashankar with Sanavi Travels. Perfect for Jyotirlinga darshan, family trips, religious tours, one-day excursions, and safe chauffeur-driven travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcabpackage;